document.addEventListener('DOMContentLoaded', () => {
  const menuItems = document.querySelectorAll('.navbar-menu-item.has-submenu');

  menuItems.forEach((menuItem, index) => {
    const submenu = menuItem.querySelector('.submenu');
    const menuLink = menuItem.querySelector('a');
    const submenuId = `submenu-${index}`;

    // Ensure submenu has a unique ID and initial aria-hidden state
    submenu.setAttribute('id', submenuId);
    submenu.setAttribute('aria-hidden', 'true');

    // Create submenu toggle button
    const submenuToggle = document.createElement('button');
    submenuToggle.classList.add('submenu-toggle');
    submenuToggle.setAttribute('aria-expanded', 'false');
    submenuToggle.setAttribute('aria-controls', submenuId);

    // Use visually hidden label for screen readers
    submenuToggle.innerHTML = `
      <span class="visually-hidden">Toggle submenu for ${menuLink.textContent}</span>
      <span class="bi bi-chevron-right" aria-hidden="true"></span>
    `;

    submenuToggle.addEventListener('click', (event) => {
      event.preventDefault();

      const isExpanded = submenuToggle.getAttribute('aria-expanded') === 'true';
      submenuToggle.setAttribute('aria-expanded', String(!isExpanded));
      submenu.setAttribute('aria-hidden', String(isExpanded));
      submenu.classList.toggle('show', !isExpanded);

      submenuToggle.innerHTML = !isExpanded
        ? `
          <span class="visually-hidden">Toggle submenu for ${menuLink.textContent}</span>
          <span class="bi bi-x" aria-hidden="true"></span>
        `
        : `
          <span class="visually-hidden">Toggle submenu for ${menuLink.textContent}</span>
          <span class="bi bi-chevron-right" aria-hidden="true"></span>
        `;
    });

    menuLink.after(submenuToggle);
  });
});